/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InvoiceItemResource } from './invoiceItemResource';


export interface InvoiceResource { 
    currency: InvoiceResource.CurrencyEnum;
    total: number;
    items: Array<InvoiceItemResource>;
}
export namespace InvoiceResource {
    export type CurrencyEnum = 'Kč' | 'Eur';
    export const CurrencyEnum = {
        K: 'Kč' as CurrencyEnum,
        Eur: 'Eur' as CurrencyEnum
    };
}


